<template>
  <div class="mypage-referral-code-page">
    <sub-header-section :pageTitle="$tc('MypagePage.MypageReferralCode.pageTitle')" />

    <referral-code-pane class="mypage-referral-code-page__content" />

    <action-buttons-section
      scrollTargetSelector=".mypage-referral-code-page__content"
      :visible="true"
    >
      <atom-input-button
        :linkText="$tc('common.back')"
        :isDisabled="false"
        colorType="tertiary"
        @push="$router.go(-1)"
      />
    </action-buttons-section>

    <global-navigation-pane current="mypage" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import SubHeaderSection from '@/components/common/Header/SubHeaderSection.vue'
import GlobalNavigationPane from '@/components/common/GlobalNavigation/GlobalNavigationPane.vue'
import ActionButtonsSection from '@/components/common/form/ActionButtonsSection.vue'
import AtomInputButton from '@/components/atoms/input/AtomInputButton.vue'
import ReferralCodePane from '@/components/MypageReferralCodePage/ReferralCodePane.vue'

/**
 * マイページ: 紹介コードページ
 */
export default defineComponent({
  name: 'MypageReferralCodePage',
  components: {
    AtomInputButton,
    SubHeaderSection,
    GlobalNavigationPane,
    ActionButtonsSection,
    ReferralCodePane,
  },
})
</script>
